var map = {
	"./icon-calendar-purple.svg": "65df",
	"./icon-check.svg": "dc7b",
	"./icon-chevron-left.svg": "a30b",
	"./icon-coverage-purple.svg": "886f",
	"./icon-livelo-purple.svg": "4f27",
	"./icon-location-purple.svg": "6ff2",
	"./icon-passengers-purple.svg": "e924",
	"./icon-person.svg": "5d28",
	"./icon-persons.svg": "5886",
	"./icon-pix-purple.svg": "5401",
	"./icon-success-purple.svg": "d437",
	"./icon-up.svg": "0cf9",
	"./icon-warning.svg": "1575"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edcb";